export default class NotificationApi {
    /**
     * Find all instances of the model matched by filter from the data source
     *
     * @param filter
     * @returns {Object}
     */
    static find(filter) {
        return axios => axios.get('/notifications', { filter });
    }

    /**
     * Get information
     *
     * @param id
     * @returns {function(*): *}
     */
    static loadData(id) {
        return axios => axios.get(`/notifications/${id}`);
    }

    /**
     * Update information
     *
     * @param id
     * @param data
     * @returns {function(*): *}
     */
    static updateData(id, data){
        return axios => axios.patch(`/notifications/${id}`, data);
    }
}



// WEBPACK FOOTER //
// ./src/api/notification.js